import React from "react";
import { SchedulerUnits } from "@sonder/ui/source/styled/layouts/SchedulerLayout";
import { GetTaskSchedulesPlace } from "core/queries/GetTaskSchedules";
import { PlaceListItem } from "schedule/components/PlaceListItem";

interface PlaceListProps {
  places: GetTaskSchedulesPlace[] | undefined;
}

export const PlaceList = ({ places }: PlaceListProps) => {
  return (
    <SchedulerUnits>
      {places &&
        places.map(place => <PlaceListItem key={place.id} place={place} />)}
    </SchedulerUnits>
  );
};
